import { render, staticRenderFns } from "./EnglishResumeLicenseCard.vue?vue&type=template&id=9f88d226&scoped=true"
import script from "./EnglishResumeLicenseCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./EnglishResumeLicenseCard.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./EnglishResumeLicenseCard.vue?vue&type=style&index=0&id=9f88d226&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f88d226",
  null
  
)

export default component.exports